@if (errorSig(); as error) {
  <div class="production-report-viewer__route-error">
    <h2>Unable to Open Report</h2>
    <p>{{ error }}</p>
  </div>
} @else {
  @if (selectedReportSig(); as selectedReport) {
    @if (!unavailableReasonSig()) {
      <dx-popup
        [showTitle]="true"
        [title]="'Report Settings'"
        [showCloseButton]="false"
        [dragEnabled]="true"
        [resizeEnabled]="true"
        [shading]="false"
        [hideOnOutsideClick]="false"
        [position]="settingsPopupPosition"
        [width]="360"
        [height]="isSettingsPopupCollapsedSig() ? 52 : 'auto'"
        [maxHeight]="settingsPopupMaxHeight"
        [minWidth]="320"
        [wrapperAttr]="{
          class:
            'production-report-viewer__settings-popup no-print' +
            (isSettingsPopupCollapsedSig() ? ' production-report-viewer__settings-popup--collapsed' : ''),
        }"
        [(visible)]="isSettingsPopupVisible"
      >
        <dxi-popup-toolbar-item
          widget="dxButton"
          location="after"
          [options]="{
            stylingMode: 'text',
            icon: isSettingsPopupCollapsedSig() ? 'chevrondown' : 'chevronup',
            hint: isSettingsPopupCollapsedSig() ? 'Expand settings' : 'Collapse settings',
            onClick: toggleSettingsPopupCollapse,
          }"
        ></dxi-popup-toolbar-item>

        <div *dxTemplate="let data of 'content'">
          @if (!isSettingsPopupCollapsedSig()) {
            <ag-shr-report-settings-form
              [formData]="settingsFormDataSig()"
              [showBranding]="showBrandingSig()"
              [brandingOptions]="brandingOptionsSig()"
              [selectedReport]="selectedReport"
              [isLoading]="stateSig().isLoading || isResolvingPeriodSig()"
              [periodSelection]="periodSelectionSig()"
              [dataAvailableThrough]="dataAvailableThroughSig()"
              [dataAvailableFrom]="dataAvailableFromSig()"
              [paidReport]="paidReportSig()"
              [periodInvalid]="periodInvalidSig() || isResolvingPeriodSig()"
              (periodSelectionChange)="onPeriodSelectionChange($event)"
              (apply)="onApply()"
              (resetToDefaults)="onResetToDefaults()"
              (templateTextChange)="onTemplateTextChange($event.field, $event.value)"
              (rowsPerPageChange)="onRowsPerPageChange($event)"
              (brandingIdChange)="onBrandingIdChange($event)"
              (variableChange)="onVariableChange($event.variable, $event.value)"
            ></ag-shr-report-settings-form>
          }
        </div>
      </dx-popup>
    }

    <div class="bulletin-report">
      <div #surfaceContainer class="bulletin-report__surface card">
        <div class="bulletin-report__toolbar-shell no-print">
          <div class="bulletin-report__header-bar">
            <div class="bulletin-report__header-main">
              <button type="button" class="bulletin-report__back-button" (click)="backToReportsList.emit()">
                <span class="bulletin-report__back-icon" aria-hidden="true">←</span>
                <span>My Reports</span>
              </button>

              <div class="bulletin-report__header-copy">
                <h2 class="bulletin-report__title" [title]="pageTitleSig()">{{ pageTitleSig() }}</h2>
                @if (realNamesWarningSig(); as warning) {
                  <p class="bulletin-report__real-names-warning" role="status">{{ warning }}</p>
                }
                <div class="bulletin-report__toolbar-meta">
                  <span class="bulletin-report__meta-pill bulletin-report__meta-pill--accent"
                    >{{ scopeLabelSig() }} view</span
                  >
                  <span class="bulletin-report__meta-pill">Bulletin</span>
                </div>
              </div>
            </div>

            @if (hasLoadedReportSig()) {
              <div class="bulletin-report__header-actions">
                @if (shouldShowReportFilter()) {
                  <ag-shr-report-entity-filter
                    class="bulletin-report__header-filter"
                    [options]="reportFilterOptionsSig()"
                    [value]="selectedReportFilterValuesSig()"
                    [placeholder]="reportFilterPlaceholderSig()"
                    [maxDisplayedTags]="1"
                    [height]="34"
                    (valueChange)="onReportFilterTagsChange($event)"
                  ></ag-shr-report-entity-filter>
                }
                <ag-shr-report-pdf-actions
                  [pdfBlob]="pdfBlobSig()"
                  [fileName]="pdfFileNameSig()"
                  [disabled]="stateSig().isLoading"
                ></ag-shr-report-pdf-actions>
                <dx-button
                  hint="Fullscreen"
                  type="normal"
                  stylingMode="outlined"
                  icon="agi-up-right-and-down-left-from-center"
                  [height]="34"
                  (onClick)="toggleFullScreen(surfaceContainer)"
                ></dx-button>
              </div>
            }
          </div>
        </div>

        <div class="production-report-viewer__preview-shell">
          <div
            #previewHost
            class="production-report-viewer__preview-wrap"
            [class.production-report-viewer__preview-wrap--pdf]="previewViewStateSig() === previewViewStates.Pdf"
            [class.production-report-viewer__preview-wrap--loading]="
              previewViewStateSig() === previewViewStates.Loading
            "
          >
            @switch (previewViewStateSig()) {
              @case (previewViewStates.Loading) {
                <div class="production-report-viewer__loading-host no-print">
                  <dx-load-panel
                    [visible]="true"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="false"
                    [hideOnOutsideClick]="false"
                    [container]="previewHost"
                    [position]="{ my: 'center', at: 'center', of: previewHost }"
                    [message]="'Loading report...'"
                  ></dx-load-panel>
                </div>
              }
              @case (previewViewStates.Unavailable) {
                <ag-shr-report-unavailable
                  [reason]="unavailableReasonSig()!"
                  [scope]="scopeSig()"
                ></ag-shr-report-unavailable>
              }
              @case (previewViewStates.Error) {
                <div class="production-report-viewer__error">{{ stateSig().errorMessage }}</div>
              }
              @case (previewViewStates.Pdf) {
                <section class="production-report-viewer__pdf-viewer no-print">
                  <iframe
                    class="production-report-viewer__pdf-frame"
                    [src]="pdfPreviewUrlSig()!"
                    title="Production report PDF preview"
                  ></iframe>
                </section>
              }
              @case (previewViewStates.Empty) {
                <div class="production-report-viewer__placeholder">
                  {{
                    isResolvingPeriodSig()
                      ? "Resolving report data availability..."
                      : periodInvalidSig()
                        ? "Select an available reporting period in Report Settings."
                        : "Unable to preview report."
                  }}
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="production-report-viewer__placeholder">Resolving report configuration...</div>
  }
}
